// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Switch, Routes } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import Login from './components/Login';
import { AuthProvider } from './auth/AuthProvider';
import Navbar from './components/Navbar';
import PatientHist from './components/PatientHist';
import PatientRecord from './components/PatientRecord';
import Timetable from './components/Timetable'
import DoctorTimeTablePage from './components/DoctorTimeTablePage';
import CalendarNote from './components/CalendarNote';
import PatientHist12Months from './components/PatientHist12Months';

const App = () => {
  return (
    <ChakraProvider>
      <AuthProvider>
          <Router>
            <Navbar />
            <main>
              <Routes>
                <Route path='/' element={<PatientRecord/>}></Route>
                <Route path='/monthly' element={<PatientHist histType={"monthly"}/>}></Route>
                <Route path='/yearly' element={<PatientHist histType={"yearly"}/>}></Route>
                <Route path='/hist_12_months' element={<PatientHist12Months/>}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/timetable" element={<Timetable />}></Route>
                <Route path="/doctor/:id" element={<DoctorTimeTablePage/>} />
                <Route path='/calendar_note' element={<CalendarNote/>}></Route>
              </Routes>
            </main>
          </Router>
        </AuthProvider>
    </ChakraProvider>
  );
};

export default App;

